import {Component} from '@angular/core';
import {SelectSnapshot} from '@ngxs-labs/select-snapshot';
import {SalesCpiAsideState} from '../../../../../../state/sales-cpi/sales-cpi-aside.state';
import {Store} from '@ngxs/store';
import {NzDrawerRef} from 'ng-zorro-antd/drawer';

@Component({
    selector: 'app-cpi-termination-aside',
    templateUrl: './cpi-termination-aside.component.html',
})
export class CpiTerminationAsideComponent {

    @SelectSnapshot(SalesCpiAsideState.step) step: number;

    constructor(private store: Store,
                private drawerRef: NzDrawerRef) {
    }

    close() {
        this.drawerRef.close();
    }
}
